<template>
  <modal name="settings-menu-modal" :width="1" :height="1" @before-open="onMenuOpen" @closed="onMenuClose">
    <div class="menu-bar right-side">
      <span class="menu-title">SETTINGS</span>
      <nav class="menu-items mt-3">
        <div v-for="item in this.links" :key="item.title" @click="closeMenu(item)">
          <router-link v-if="isEnabled(item)" :to="item.link" replace @click.prevent.native="actionHandler(item.action)">
            <span :class="{'menu-item-active' : isActive(item)}">{{item.title}}</span>
            <toggle-button v-if="item.action === 'notification'"
                           class="ml-3 mb-0"
                           :value="notificationsEnabled"
                           :sync="true"
                           :width="30"
                           :height="14"
                           :css-colors="true"
                           :margin="1"/>
          </router-link>
        </div>
      </nav>
    </div>
  </modal>
</template>
<script>
import { mapState } from 'vuex'
import SignIn from '../views/SignIn.vue'
import SignOut from '../views/SignOut.vue'
import PasswordResetRequest from '../views/PasswordResetRequest.vue'
import PasswordResetPerform from '../views/PasswordResetPerform.vue'
import DeleteAccount from '../views/DeleteAccount.vue'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  computed: mapState({
    isRegisteredUser: state => state.isRegisteredUser,
    notificationsEnabled: state => state.notificationsEnabled
  }),
  components: {
    ToggleButton
  },
  mounted () {
    this.$store.subscribe(mutation => {
      switch (mutation.type) {
        case 'startSignIn':
          this.actionHandler('signin')
          break
        case 'startPasswordReset':
          this.actionHandler('passwordResetRequest')
          break
        case 'performPasswordReset':
          this.actionHandler('passwordResetPerform')
          break
        case 'showDeleteAccount':
          this.actionHandler('showDeleteAccount')
          break
      }
    })
  },
  data: function () {
    return {
      links: [
        {
          title: 'Profile',
          link: '/profile',
          group: 'registered'
        },
        {
          title: 'App Info',
          link: '/appInfo',
          group: 'common'
        },
        {
          title: 'Imprint',
          link: '/imprint',
          group: 'common'
        },
        {
          title: 'Feedback',
          link: '/#feedback',
          group: 'common',
          action: 'feedback'
        },
        {
          title: 'Notification',
          link: '/#notification',
          group: 'common',
          action: 'notification'
        },
        {
          title: 'Sign in',
          link: '/#signin',
          group: 'casual',
          action: 'signin'
        },
        {
          title: 'Sign out',
          link: '/#signout',
          group: 'registered',
          action: 'signout'
        }
      ]
    }
  },
  methods: {
    isActive (item) {
      return this.$route.path === item.link
    },
    isEnabled (item) {
      return item.group === 'common' || item.group === (this.isRegisteredUser ? 'registered' : 'casual')
    },
    closeMenu (item) {
      if (item.action !== 'notification') {
        console.info('SettingsMenu: closing...')
        this.$emit('closeMenu')
      }
    },
    onMenuOpen () {
      this.$store.commit('muteNotifications')
    },
    onMenuClose () {
      this.$store.commit('unmuteNotifications')
    },
    actionHandler (action) {
      console.info('Link clicked ' + action)
      switch (action) {
        case 'signin':
          this.renderModal('signin-modal', SignIn, {
            reason: this.$store.state.signInReason
          })
          break
        case 'signout':
          this.renderModal('signout-modal', SignOut, {})
          break
        case 'passwordResetRequest':
          this.renderModal('password-reset-request-modal', PasswordResetRequest, {
            defaultUsername: this.$store.state.defaultUsername
          })
          break
        case 'passwordResetPerform':
          this.renderModal('password-reset-perform-modal', PasswordResetPerform, {
            token: this.$store.state.passwordResetToken
          })
          break
        case 'showDeleteAccount':
          this.renderModal('delete-account-modal', DeleteAccount, {})
          break
        case 'feedback':
          location.href = 'mailto:support@aftv.co.uk'
          break
        case 'notification':
          this.$store.commit('toggleNotifications')
          break
      }
    },
    async renderModal (name, obj, param) {
      this.$modal.show(obj, param, {
        name: name,
        classes: ['app-modal col-sm-12 col-md-10 col-lg-8 col-xl-6'],
        height: 'auto',
        adaptive: true
      })
    }
  }
}
</script>
